<!--
  @component
  Generates an SVG line shape.
 -->
<script>
  import { getContext } from "svelte";

  const { data, xGet, yGet, x, y, custom } = getContext("LayerCake");

  /**
   * @typedef {Object} Props
   * @property {string} [stroke='#fdbf11'] - The shape's fill color. This is technically optional because it comes with a default value but you'll likely want to replace it with your own color.
   * @property {Object|null} hoveredPoint
   */

  /** @type {Props} */
  let { stroke = "#fdbf11", hoveredPoint = $bindable(null) } = $props();

  function path(values) {
    let build_a_path = "M";
    for (let i in values) {
      if ($yGet(values[i]) == undefined && i != 0 && build_a_path[build_a_path.length - 1] != "M") {
        build_a_path = build_a_path.substring(0, build_a_path.length - 1) + "M";
      } else if ($yGet(values[i]) != undefined) {
        build_a_path += $xGet(values[i]) + "," + $yGet(values[i]) + "L";
      }
    }
    return build_a_path.substring(0, build_a_path.length - 1);
  }
</script>

<path class="path-line" d={path($data)} {stroke}></path>
<g class="points">
  {#each $data as point}
    <circle
      r="5"
      cx={$xGet(point)}
      cy={$yGet(point)}
      fill="white"
      stroke={$custom.seriesColors[0]}
      stroke-width="2"
    ></circle>
  {/each}
</g>
<g class="hover-points">
  {#each $data as point}
    <circle
      class="hoverable-point"
      r="10"
      cx={$xGet(point)}
      cy={$yGet(point)}
      aria-describedby="tooltip"
      fill="transparent"
      onmousemove={(e) => {
        hoveredPoint = {
          x: e.target.cx,
          y: e.target.cy,
          target: e.target,
          state: $custom.currentState,
          year: $x(point),
          value: $y(point)
        };
      }}
      onmouseout={() => {
        hoveredPoint = null;
      }}
      onblur={() => {
        hoveredPoint = null;
      }}
    ></circle>
  {/each}
</g>

<style>
  .path-line {
    fill: none;
    stroke-linejoin: round;
    stroke-linecap: round;
    stroke-width: 2;
  }
</style>
